export default "<span class=\"h1 font-bold\">Radio An</span>"